import { type ConfluenceDatabaseUpdateCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';

import { DatabaseStreamState } from '../database-stream-state';

const streamState = DatabaseStreamState.getInstance();

export const editDatabase = async (
  params: ConfluenceDatabaseUpdateCommandProperties,
  contentId: string
) => {
  if (params.isStreamComplete) {
    streamState.completeStreaming();
    return;
  }

  if (!streamState.isStreamingActive) {
    streamState.startStreaming(contentId, params.groupId, {
      operationType: 'edit',
    });
  }

  streamState.processChunk(params.data.document);
};
